<template>
  <transition name="el-fade-in-linear">
    <div v-show="shown.mainshow">
      <div class="main_wrap">
        <div class="commonhead">
          <com-head></com-head>
        </div>
        <div class="head_wrap"></div>
        <div class="body_wrap">
          <div class="baseinfo_content">
            <el-page-header @back="toHome" :title="$t('App.page.details.pageheader_title')"
              :content="$t('App.page.details.pageheader_details')">
            </el-page-header>
            <el-divider></el-divider>
            <div class="left_image">
              <img :src="formatProductImage(pageData.item.img)" />
            </div>
            <div class="right_content">
              <div class="item_title">
                {{ pageData.item.name }}
              </div>
              <div class="span_info">
                <el-form class="form_details" :label-position="pageData.labelPosition" label-width="7rem">
                  <el-form-item :label="$t('App.page.details.price')">
                    <div class="item_info">
                      <span style="color: #f13a3a">{{
                        pageData.item.sign
                      }}</span><span style="color: #f13a3a; font-size: 1.2rem">{{
                          pageData.item.saleprice
                        }}</span>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('App.page.details.quantity')" v-if="
                    pageData.item.id != 'PD830215946' &&
                    pageData.item.id != 'PD8302305836' &&
                    pageData.item.id != 'PD3486991625' &&
                    pageData.item.id != 'PD3486995656'
                  ">
                    <div class="user_domain">
                      <el-input-number :min="1" :max="9999" size="mini" v-model="formData.quantity"></el-input-number>
                      <el-button class="btn_addcart" type="success" circle icon="el-icon-shopping-bag-2" size="mini"
                        @click="toCart(pageData.item, formData.quantity)"></el-button>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('App.page.details.label_boxpcs')">
                    <div class="user_domain">
                      <el-input-number :min="1" :max="9999" size="mini" v-model="formData.quantityBox"
                        :step="Number(pageData.item.boxpcs)" step-strictly></el-input-number>
                      <el-button class="btn_addcart" type="success" circle icon="el-icon-shopping-bag-2" size="mini"
                        @click="toCart(pageData.item, formData.quantityBox)"></el-button>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div class="otherinfo_content">
            <el-divider></el-divider>
            <el-col>{{ $t("App.page.details.label_sku")
            }}{{ pageData.item.sku }}</el-col>
            <el-col>{{ $t("App.page.details.label_ean")
            }}{{ pageData.item.ean }}</el-col>
            <el-col>{{ $t("App.page.details.label_weight")
            }}{{ pageData.item.weight }}kg</el-col>
            <el-col>{{ $t("App.page.details.label_rweight")
            }}{{ pageData.item.rweight }}kg</el-col>
            <el-col>{{ $t("App.page.details.label_boxpcs")
            }}{{ pageData.item.boxpcs }}pcs</el-col>
            <el-col>{{ $t("App.page.details.label_feature")
            }}{{ pageData.item.feature }}cm</el-col>
            <el-col>{{ $t("App.page.details.label_description")
            }}{{ pageData.item.description }}</el-col>
          </div>
        </div>
        <div class="foot_wrap"><com-foot></com-foot></div>
      </div>
    </div>
  </transition>
</template>

<script>
import Head from "@/components/customer/customerCommonHeader";
import Foot from "@/components/customer/customerCommonFooter";
import * as cartjs from "@/assets/js/cart";
import * as verifyjs from "@/assets/js/verify";
export default {
  data() {
    return {
      api: '',
      shown: {
        mainshow: false,
      },
      pageData: {
        custUserinfo: {},
        newCartItem: {},
        username: '',
        user: {},
        labelPosition: 'left',
        item: {},
        discountRules: [],
      },
      formData: {
        quantity: 1,
        quantityBox: 0
      },
    };
  },
  mounted() {
    this.prepareForMounted();
  },
  methods: {
    prepareForMounted() {
      this.api = (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_PREFIX) || process.env.API_PREFIX || '';
      this.pageData.item = this.$route.query;
      this.pageData.username = sessionStorage.getItem('username');
      this.pageData.custUserinfo = JSON.parse(sessionStorage.getItem(this.pageData.username));
      this.pageData.discountRules = JSON.parse(sessionStorage.getItem('disocunt_rules'));

      this.formData.quantityBox = Number(this.pageData.item.boxpcs)
      if (verifyjs.isMounted(this)) {
        document.title = this.pageData.item.name + ' - iFi Audio';
        setTimeout(() => { this.shown.mainshow = true }, 1);
      } else {
        this.$router.push({ name: 'Login' });
      }
    },
    toHome() {
      this.$router.push({ name: "Home" });
    },
    toCart(item, quantity) {
      this.pageData.newCartItem.productid = item.id;
      this.pageData.newCartItem.productname = item.name;
      this.pageData.newCartItem.quantity = quantity;
      this.pageData.newCartItem.uniprice = item.saleprice;
      this.pageData.newCartItem.scount = this.pageData.custUserinfo.discount;
      this.pageData.newCartItem.disprice = this.pageData.newCartItem.uniprice * (1 - this.pageData.newCartItem.scount);
      this.pageData.newCartItem.subprice = 0.00;
      this.pageData.newCartItem.weight = item.weight;
      this.pageData.newCartItem.rweight = item.rweight;
      this.pageData.newCartItem.sign = item.sign;
      this.pageData.newCartItem.img = item.img;

      this.pageData.user.username = this.pageData.username;

      cartjs.addToCart(this, this.pageData.user, this.pageData.newCartItem).then((val) => {
        if (val) {
          this.$router.push({ name: "Cart" });
        }
      });
    },
    formatProductImage(img) {
      if (!img || img.length === 0) return ''
      // If already base64 or full URL, return as is
      if (img.indexOf('data:image') === 0 || img.indexOf('http') === 0) {
        return img
      }
      // If starts with images/ or /images/, prepend the product image server URL
      if (img.indexOf('images/') === 0 || img.indexOf('/images/') === 0) {
        // Convert 'images/xxx.jpg' or '/images/xxx.jpg' to '/images/xxx.jpg'
        const cleanImg = img.replace(/^images\//, '/images/')
        return cleanImg
      }
      // Otherwise, prepend API prefix
      return (this.api || '') + img
    }
  },
  components: {
    'com-head': Head,
    'com-foot': Foot
  },
};
</script>

<style scoped>
.main_wrap {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  position: fixed;
  overflow: auto;
}

.body_wrap {
  clear: both;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: 10rem;
  overflow: auto;
}

.baseinfo_content {
  margin: 0 auto;
  width: 100rem;
  overflow: auto;
}

.left_image {
  float: left;
  width: 40rem;
}

.left_image img {
  width: 25rem;
}

.right_content {
  float: left;
  width: 40rem;
  margin-top: 4rem;
}

.item_title {
  margin-left: 10rem;
  font-size: 1.4rem;
  color: #606266;
}

.span_info {
  margin-left: 18rem;
  margin-top: 2rem;
}

.form_details {
  margin: 3rem auto;
}

.form_details .el-form-item {
  font-size: 1rem;
  color: #303133;
}

.item_info,
.user_domain {
  width: 15rem;
  text-align: left;
}

.btn_addcart {
  margin-left: 1rem;
}

.otherinfo_content {
  margin: 0 auto;
  width: 100rem;
  color: #606266;
  font-size: 0.9rem;
  text-align: left;
  line-height: 2rem;
  padding: 3rem;
}

.foot_wrap {
  overflow: hidden;
  /* margin-top: -13rem; */
}
</style>


// WEBPACK FOOTER //
// src/views/customer/Details.vue